import React from "react";

export function StockSummary(props) {
    return (
        <div className={"chart-values container"}>
            <table>
                <tbody>
                    <tr>
                        <td>Open</td>
                        <th>{props.stockData?.ticker?.open.toFixed(2)}</th>
                        <td>Mkt cap</td>
                        <th>{props.formatMarketCap}</th>
                    </tr>
                    <tr>
                        <td>High</td>
                        <th>{props.stockData?.ticker?.heigh.toFixed(2)}</th>
                        <td>P/E ratio</td>
                        <th>{props.stockData?.ticker?.pe_value}</th>
                    </tr>
                    <tr>
                        <td>Low</td>
                        <th>{props.stockData?.ticker?.low.toFixed(2)}</th>
                        <td>Div yield</td>
                        <th>{props.stockData?.ticker?.div_yield}</th>
                    </tr>
                </tbody>
            </table>
        </div>
    );
}
